var CACHE_CONSTANTS = {
    MAX_SIZE: (function () {
        if (typeof process === 'undefined') {
            return 50;
        }
        if (process.env['NODE_ENV'] === 'production') {
            if (typeof window === 'undefined') {
                return 500;
            }
            else {
                return 50;
            }
        }
        else {
            return 5;
        }
    })(),
    WARN_THRESHOLD: 0.8,
    DEFAULT_LOG_LEVEL: 'info',
    PRUNE_STRATEGY: 'LRU',
};

export { CACHE_CONSTANTS };
